'use strict';

const MOBILE_PHONE_CONSTANTS = {
  MESSAGES: {
    REQUEST_INQUIRY: {
      ID: 1,
    },
    PRIVACY: {
      ID: 2,
    },
    SHOW: {
      ID: 3,
    },
    IN_REVISION: {
      ID: 4,
    },
    NOT_AVAILABLE: {
      ID: 5,
    },
  },
  QUALIFICATION_LEVELS: {
    LEVEL_0: {
      ID: 0,
    },
    LEVEL_1: {
      ID: 1,
    },
    LEVEL_2: {
      ID: 2,
    },
    LEVEL_3: {
      ID: 3,
    },
  },
};

export {
  MOBILE_PHONE_CONSTANTS,
};
